<div class="main-dialog" *ngIf="dialog">
    <!-- <nb-card *ngIf="dialog" class="dialog-container">
        <nb-card-header class="dialog-header">
            <h2 class="header-text">«سیاست نامه حریم خصوصی وقوانین ومقررات استفاده از سامانه دادگام»</h2>
            <button nbButton status="primary" class="header-btn" (click)="close()">تایید</button>
        </nb-card-header>
        <nb-card-body>
            <ng-container *ngTemplateOutlet="policyBody"></ng-container>
        </nb-card-body>
    </nb-card> -->
    <nb-card class="dialog-card">
        <nb-card-body class="dialog-container">
            <div class="text">
                کلیک بر روی گزینه زیر به منزله تایید <a [href]="privacyLinkUrl" target="_blank">قوانین و مقررات </a> وبسایت حقوقی دادگام است.
            </div>
            <button nbButton status="primary" class="header-btn" (click)="close('confirm')">تایید</button>
        </nb-card-body>
    </nb-card>
</div>

<div *ngIf="!dialog" class="container">
    <div class="header">
        <h2 class="header-text">«سیاست نامه حریم خصوصی وقوانین ومقررات استفاده از سامانه دادگام»</h2>
    </div>
    <ng-container *ngTemplateOutlet="policyBody"></ng-container>
</div>

<ng-template #policyBody>
    <div *ngFor="let item of text" class="body">
        <h5 class="titles"> {{item.title}} </h5>
        <p class="paragh-text" *ngFor="let parag of item.description"> {{parag.p}}</p>
    </div>
    <div *ngFor="let rule of rules">
        <h5 class="titles"> {{rule.title}} </h5>
        <div *ngFor="let title of rule.rule">
            <h6 class="titles-in"> {{title.title}} </h6>
            <p class="paragh-text" *ngFor="let item of title.description"> {{item.p}} </p>
        </div>
    </div>
</ng-template>